import { Controller } from "@hotwired/stimulus"

// Keep editing uninterrupted when Turbo replaces a live-search form.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.beforeRender = this.beforeRender.bind(this)
    document.addEventListener("turbo:before-frame-render", this.beforeRender)
    document.addEventListener("turbo:before-render", this.beforeRender)
  }

  submit(event) {
    clearTimeout(this.timeout)
    if (event?.isComposing) return
    this.timeout = setTimeout(() => {
      this.timeout = null
      this.element.requestSubmit()
    }, this.delayValue)
  }

  submitNow() {
    clearTimeout(this.timeout)
    this.timeout = null
    this.element.requestSubmit()
  }

  beforeRender(event) {
    const input = document.activeElement
    if (!this.element.contains(input) || input.type !== "search") return
    if (event.type === "turbo:before-frame-render" && !event.target.contains(this.element)) return

    const render = event.detail.render
    event.detail.render = async (...args) => {
      // Read at render time, including edits made while the request was in flight.
      const value = input.value
      const start = input.selectionStart
      const end = input.selectionEnd
      const direction = input.selectionDirection
      const pending = this.timeout != null
      await render(...args)
      const replacement = document.getElementById(input.id)
      if (!replacement || replacement.type !== "search") return
      replacement.value = value
      replacement.focus({ preventScroll: true })
      replacement.setSelectionRange(start, end, direction)
      // Disconnect cancels the old form's debounce; carry unfinished edits forward.
      if (pending) replacement.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener("turbo:before-frame-render", this.beforeRender)
    document.removeEventListener("turbo:before-render", this.beforeRender)
  }
}
